import { fetchRequest } from "@providers/conect";

const storeCitaEmpApi = async (data) => {
  try {
    const url = `agendawp/citas-emp`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: {
        ...data,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { storeCitaEmpApi };
